import { FC } from 'react';

import { useReportPoller } from 'hooks/tradePromoOptimization/useReportPoller';
import { BulkExportReportRow } from 'utils/getTradePromoOptimizationTableColumns';

type ReportPollerProps = {
    reportId: number | string;
    initialStatus?: string;
    onUpdate: (id: number | string, patch: Partial<BulkExportReportRow>) => void;
};

/** Mount/unmount wrapper around `useReportPoller`; renders nothing. */
const ReportPoller: FC<ReportPollerProps> = (props) => {
    useReportPoller(props);
    return null;
};

export default ReportPoller;
